<script setup lang="ts">
import VText from '~/components/ui/VText.vue'

import { hasSlotContent } from '~/utils/hasSlot'

import type HtmlTag from '~/types/htmlTag'

type Props = {
  light?: boolean
  titleHtmlTag?: HtmlTag
}
type Slots = {
  number(): any
  title(): any
  subtitle(): any
}

defineSlots<Slots>()
withDefaults(defineProps<Props>(), {
  light: false,
  titleHtmlTag: 'span',
})
</script>

<template>
  <div class="tw-relative tw-mb-8 tw-flex tw-w-full tw-flex-col tw-flex-wrap">
    <div class="tw-flex tw-items-center tw-justify-start tw-gap-2">
      <div class="tw-flex tw-items-baseline tw-justify-start tw-gap-2">
        <span
          v-if="hasSlotContent($slots['number'])"
          class="number tw-font-title tw-text-orange-500"
          :class="[light ? 'tw-text-2xl' : 'tw-text-[32px]']"
        >
          <slot name="number" />
        </span>
        <component
          :is="titleHtmlTag"
          :html-tag="titleHtmlTag"
          class="tw-inline-block tw-w-full tw-font-title"
          :class="{ 'tw-text-2xl': !light, 'tw-text-xl': light }"
        >
          <slot name="title" />
        </component>
      </div>
      <VText
        v-if="hasSlotContent($slots['subtitle'])"
        cfg="sans/14/medium"
        color="black"
      >
        <slot name="subtitle" />
      </VText>
    </div>
    <div
      class="tw-mt-4 tw-h-2 tw-w-12 tw-rounded-xs tw-bg-orange-500"
      :class="{
        '!tw-h-1': light,
      }"
    />
  </div>
</template>
